import React from 'react';
import MasterLayout from '../layouts/masterlayout';

const pageTitle = 'Help Page';

function HelpPage() {    
    return (
        <MasterLayout pageTitle={pageTitle}>            
            <div className="flex flex-col items-center justify-center h-screen">
                <h1 className="text-4xl font-bold mb-4">Welcome to the Help Section</h1>
                <p className="text-lg">More information will be added here soon.</p>
            </div>
        </MasterLayout>);
}

export default HelpPage;
